var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipe--rating-container"},[_c('strong',[_vm._v("Betyg")]),_vm._v(" "),_c('div',{staticClass:"recipe--rating"},[_c('span',{staticClass:"recipe--rating-result",style:('width:' + _vm.getRatingScore(150) + 'px')})])])
}
var staticRenderFns = []

export { render, staticRenderFns }